import axios from '@utils/axios-client'

export async function getDefaultMark () {
  const response = axios.get('/api/v1/Gmts/GetDefaultMark')
  return (await response).data
}

export async function getPriceRange () {
  const response = axios.get('/api/v1/PriceRange')
  return (await response).data
}
